var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedReaction = useAnimatedReaction;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
var _core = require("../core");
var _useSharedValue = require("./useSharedValue");
var _PlatformChecker = require("../PlatformChecker");
var _worklet_3805047105816_init_data = {
    code: "function anonymous(){const{prepare,react,previous}=this.__closure;const input=prepare();react(input,previous.value);previous.value=input;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedReaction.ts",
    sourceMap: '{"version":3,"names":["anonymous","prepare","react","previous","__closure","input","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedReaction.ts"],"mappings":"AA4CgB,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,KAAA,CAAAC,QAAA,OAAAC,SAAA,CAEhB,KAAM,CAAAC,KAAK,CAAGJ,OAAO,CAAC,CAAC,CACvBC,KAAK,CAACG,KAAK,CAAEF,QAAQ,CAACG,KAAK,CAAC,CAC5BH,QAAQ,CAACG,KAAK,CAAGD,KAAK,CACxB"}',
    version: "3.5.4"
};
function useAnimatedReaction(prepare, react, dependencies) {
    var _prepare$__closure;
    var previous = (0, _useSharedValue.useSharedValue)(null, true);
    var inputs = Object.values((_prepare$__closure = prepare.__closure) != null ? _prepare$__closure : {});
    if ((0, _PlatformChecker.shouldBeUseWeb)()) {
        var _dependencies;
        if (!inputs.length && (_dependencies = dependencies) != null && _dependencies.length) {
            inputs = dependencies;
        }
    }
    if (dependencies === undefined) {
        var _prepare$__closure2, _react$__closure;
        dependencies = [].concat((0, _toConsumableArray2.default)(Object.values((_prepare$__closure2 = prepare.__closure) != null ? _prepare$__closure2 : {})), (0, _toConsumableArray2.default)(Object.values((_react$__closure = react.__closure) != null ? _react$__closure : {})), [
            prepare.__workletHash,
            react.__workletHash
        ]);
    } else {
        dependencies.push(prepare.__workletHash, react.__workletHash);
    }
    (0, _react.useEffect)(function() {
        var fun = function() {
            var _e = [
                new global.Error(),
                -4,
                -27
            ];
            var anonymous = function anonymous() {
                var input = prepare();
                react(input, previous.value);
                previous.value = input;
            };
            anonymous.__closure = {
                prepare: prepare,
                react: react,
                previous: previous
            };
            anonymous.__initData = _worklet_3805047105816_init_data;
            anonymous.__workletHash = 3805047105816;
            anonymous.__stackDetails = _e;
            return anonymous;
        }();
        var mapperId = (0, _core.startMapper)(fun, inputs, []);
        return function() {
            (0, _core.stopMapper)(mapperId);
        };
    }, dependencies);
}
